module.exports = __webpack_public_path__ + "img/images/new-landing/bg.png?be50ac35";